/**
 * Golden Hour announcement bar: one short message at a time.
 *
 * Holds still on hover and on focus, and never starts when the visitor has
 * asked for less motion. There is no aria-live: a message that changes every
 * five seconds forever would talk over a screen reader.
 */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  const setUp = (bar) => {
    const items = bar.querySelectorAll('[data-ghw-announce-item]');
    if (items.length < 2) return;

    const interval = Number(bar.dataset.interval) || 5000;
    let index = 0;
    let timer = null;

    const show = (next) => {
      index = (next + items.length) % items.length;
      items.forEach((item, i) => {
        const active = i === index;
        item.toggleAttribute('data-active', active);
        if (active) {
          item.removeAttribute('aria-hidden');
        } else {
          item.setAttribute('aria-hidden', 'true');
        }
      });
    };

    const stop = () => {
      window.clearInterval(timer);
      timer = null;
    };

    const start = () => {
      if (timer || reduceMotion.matches || document.hidden) return;
      timer = window.setInterval(() => show(index + 1), interval);
    };

    bar.addEventListener('mouseenter', stop);
    bar.addEventListener('mouseleave', start);
    bar.addEventListener('focusin', stop);
    bar.addEventListener('focusout', start);

    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stop();
      } else {
        start();
      }
    });

    reduceMotion.addEventListener('change', () => {
      if (reduceMotion.matches) {
        stop();
      } else {
        start();
      }
    });

    start();
  };

  const init = () => document.querySelectorAll('[data-ghw-announce]').forEach(setUp);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
